import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext } from '@nuxtjs/composition-api';
import type { JobsSection } from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';
import PortfolioVisibilityIndicator from '@/components/partials/public-portfolio/PortfolioVisibilityIndicator/PortfolioVisibilityIndicator.vue';
import PortfolioButton from '@/components/partials/public-portfolio/PortfolioButton/PortfolioButton.vue';
import { EDIT_SECTION_EVENT_NAME } from '@/components/partials/public-portfolio/constants';
import { Variant } from '~/components/partials/public-portfolio/PortfolioButton/types';
import PortfolioJobsInquirySectionField from '~/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionField/PortfolioJobsInquirySectionField.vue';

type PortfolioJobsInquirySectionProfileSectionProps = {
  section: JobsSection;
};
type PortfolioJobsInquirySectionProfileSectionEmits = {
  (event: 'edit-field', sectionTitle: string, fieldName?: string): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioJobsInquirySectionProfileSection',
  props: {
    section: null
  },
  emits: ["edit-field"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'edit-field', sectionTitle: string, fieldName?: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  section: JobsSection;
};



const { $analytics } = useContext();

const visibleFields = computed(() => props.section.fields.filter(({ attrs: { isHidden } }) => !isHidden));

function emitEdit(sectionTitle: string, fieldName?: string): void {
  $analytics?.logEvent(EDIT_SECTION_EVENT_NAME, {
    name: sectionTitle,
    fieldName,
  });

  emit('edit-field', props.section.editModalConfig.name, fieldName);
}

function handleEditField(fieldName: string): void {
  if (props.section.editModalConfig.title) emitEdit(props.section.editModalConfig.title, fieldName);
}

function handleEditSection(): void {
  if (props.section.editModalConfig.title) emitEdit(props.section.editModalConfig.title);
}

return { __sfc: true,props, emit, $analytics, visibleFields, emitEdit, handleEditField, handleEditSection, PortfolioVisibilityIndicator, PortfolioButton, Variant, PortfolioJobsInquirySectionField }
}

})